import Community from './index';

export default {
    path: '/home/community',
    component: Community,
    children: []
}